module.exports = "https://trybtryb-legacy.web.app/img/oval-transparent-mobile.cca9a8ca.svg";